import { QuestionAnswer } from "~/models/questionAnswer";
import { Topic } from "~/models/topic";

const questionContentFilterRegexes: RegExp[] = [
  /\[([^\]]*)]/gi,
  /【([^】]*)】/gi,
  /「([^」]*)」/gi,
  /『([^』]*)』/gi,
];

export function filterQuestionContentForDisplay({
  questionContent,
  topic,
}: {
  questionContent: QuestionAnswer["questionContent"];
  topic: Topic;
}): string {
  if (!questionContent) {
    return "";
  }
  let filtered = questionContent;
  const topicNames = generateTopicNamesForComparison({
    topic,
  });

  questionContentFilterRegexes.forEach((regex) => {
    filtered = filtered.replace(regex, (match, targetText) => {
      const targetTextForComparison = modifyStringForComparison(targetText);

      for (const name of topicNames) {
        if (targetTextForComparison === name) {
          return "";
        }
      }

      return match;
    });
  });

  return filtered.trim();
}

function modifyStringForComparison(text: string) {
  return text.toLowerCase().replace(/\s/gi, "");
}

function generateTopicNamesForComparison({ topic }: { topic: Topic }) {
  const words = generateTopicNameWordsArray({ topic });
  return words.map((word) => modifyStringForComparison(word));
}

// generate every possible combination of words from topic names
function generateTopicNameWordsArray({ topic }: { topic: Topic }) {
  const results: string[] = [];

  const originalNames = [topic.name];
  if (topic.nameEn) {
    originalNames.push(topic.nameEn);
  }
  if (topic.shortName) {
    originalNames.push(topic.shortName);
  }

  originalNames.forEach((topicName) => {
    const words = topicName.split(" ");

    const combinations: string[][] = [];

    for (let i = 0; i < words.length; i++) {
      for (let j = i; j < words.length; j++) {
        combinations.push(words.slice(i, j + 1));
      }
    }

    combinations.forEach((combination) => results.push(combination.join(" ")));
  });

  return results;
}
